export default "__VITE_ASSET__rXTeH1yn__"